export interface CaqPorEtapaDto {
  fatorPonderacao: number;
  mediana: number;
  numeroMatriculas: number;
  numeroEscolas: number;
}

export interface DadosRelatorioCaqDto {
  crecheUrbanaIndepLocDiferenciadaParcial: CaqPorEtapaDto;
  crecheUrbanaIndepLocDiferenciadaIntegral: CaqPorEtapaDto;
  preEscolaUrbanaIndepLocDiferenciadaParcial: CaqPorEtapaDto;
  preEscolaUrbanaIndepLocDiferenciadaIntegral: CaqPorEtapaDto;
  ensFunAnosIniciaisUrbanaIndepLocDiferenciadaParcial: CaqPorEtapaDto;
  ensFunAnosIniciaisUrbanaIndepLocDiferenciadaIntegral: CaqPorEtapaDto;
  ensFunAnosFinaisUrbanaIndepLocDiferenciadaParcial: CaqPorEtapaDto;
  ensFunAnosFinaisUrbanaIndepLocDiferenciadaIntegral: CaqPorEtapaDto;
  ensMedioUrbanaIndepLocDiferenciadaParcial: CaqPorEtapaDto;
  ensMedioUrbanaIndepLocDiferenciadaIntegral: CaqPorEtapaDto;
  ejaUrbanaIndepLocDiferenciadaParcial: CaqPorEtapaDto;
  ejaUrbanaIndepLocDiferenciadaIntegral: CaqPorEtapaDto;

  crecheUrbanaParcial: CaqPorEtapaDto;
  crecheUrbanaIntegral: CaqPorEtapaDto;
  crecheRuralParcial: CaqPorEtapaDto;
  crecheRuralIntegral: CaqPorEtapaDto;
  crecheCampoParcial: CaqPorEtapaDto;
  crecheCampoIntegral: CaqPorEtapaDto;
  crecheTerraIndigenaParcial: CaqPorEtapaDto;
  crecheTerraIndigenaIntegral: CaqPorEtapaDto;
  crecheQuilombolaParcial: CaqPorEtapaDto;
  crecheQuilombolaIntegral: CaqPorEtapaDto;

  preEscolaUrbanaParcial: CaqPorEtapaDto;
  preEscolaUrbanaIntegral: CaqPorEtapaDto;
  preEscolaRuralParcial: CaqPorEtapaDto;
  preEscolaRuralIntegral: CaqPorEtapaDto;
  preEscolaCampoParcial: CaqPorEtapaDto;
  preEscolaCampoIntegral: CaqPorEtapaDto;
  preEscolaTerraIndigenaParcial: CaqPorEtapaDto;
  preEscolaTerraIndigenaIntegral: CaqPorEtapaDto;
  preEscolaQuilombolaParcial: CaqPorEtapaDto;
  preEscolaQuilombolaIntegral: CaqPorEtapaDto;

  ensFunAnosIniciaisUrbanaParcial: CaqPorEtapaDto;
  ensFunAnosIniciaisUrbanaIntegral: CaqPorEtapaDto;
  ensFunAnosIniciaisRuralParcial: CaqPorEtapaDto;
  ensFunAnosIniciaisRuralIntegral: CaqPorEtapaDto;
  ensFunAnosIniciaisCampoParcial: CaqPorEtapaDto;
  ensFunAnosIniciaisCampoIntegral: CaqPorEtapaDto;
  ensFunAnosIniciaisTerraIndigenaParcial: CaqPorEtapaDto;
  ensFunAnosIniciaisTerraIndigenaIntegral: CaqPorEtapaDto;
  ensFunAnosIniciaisQuilombolaParcial: CaqPorEtapaDto;
  ensFunAnosIniciaisQuilombolaIntegral: CaqPorEtapaDto;

  ensFunAnosFinaisUrbanaParcial: CaqPorEtapaDto;
  ensFunAnosFinaisUrbanaIntegral: CaqPorEtapaDto;
  ensFunAnosFinaisRuralParcial: CaqPorEtapaDto;
  ensFunAnosFinaisRuralIntegral: CaqPorEtapaDto;
  ensFunAnosFinaisCampoParcial: CaqPorEtapaDto;
  ensFunAnosFinaisCampoIntegral: CaqPorEtapaDto;

  ensFunAnosFinaisTerraIndigenaParcial: CaqPorEtapaDto;
  ensFunAnosFinaisTerraIndigenaIntegral: CaqPorEtapaDto;

  ensFunAnosFinaisQuilombolaParcial: CaqPorEtapaDto;
  ensFunAnosFinaisQuilombolaIntegral: CaqPorEtapaDto;

  ensMedioUrbanaParcial: CaqPorEtapaDto;
  ensMedioUrbanaIntegral: CaqPorEtapaDto;
  ensMedioRuralParcial: CaqPorEtapaDto;
  ensMedioRuralIntegral: CaqPorEtapaDto;
  ensMedioCampoParcial: CaqPorEtapaDto;
  ensMedioCampoIntegral: CaqPorEtapaDto;

  ensMedioTerraIndigenaParcial: CaqPorEtapaDto;
  ensMedioTerraIndigenaIntegral: CaqPorEtapaDto;

  ensMedioQuilombolaParcial: CaqPorEtapaDto;
  ensMedioQuilombolaIntegral: CaqPorEtapaDto;

  ejaUrbanaParcial: CaqPorEtapaDto;
  ejaRuralParcial: CaqPorEtapaDto;
  ejaCampoParcial: CaqPorEtapaDto;
  ejaTerraIndigenaParcial: CaqPorEtapaDto;
  ejaQuilombolaParcial: CaqPorEtapaDto;

  // R2: Detalhamento por Dependência Administrativa (Novas Salas)
  projecaoDespesaConstrucaoNovosPrediosEdInfantilGovernoEstadual?: number;
  projecaoDespesaConstrucaoNovosPrediosEnsFunEnsMedioEjaGovernoEstadual?: number;
  projecaoDespesaConstrucaoNovosPrediosEdInfantilGovernoMunicipal?: number;
  projecaoDespesaConstrucaoNovosPrediosEnsFunEnsMedioEjaGovernoMunicipal?: number;

  projecaoDespesaConstrucaoNovosPrediosTotalGovernoEstadual?: number;
  projecaoDespesaConstrucaoNovosPrediosTotalGovernoMunicipal?: number;
  projecaoDespesaConstrucaoNovosPrediosTotal?: number;

  percDespesaConstrucaoNovosPrediosEdInfantilGovernoEstadual?: number;
  percDespesaConstrucaoNovosPrediosEnsFundEnsMedioEjaGovernoEstadual?: number;
  percDespesaConstrucaoNovosPrediosEdInfantilGovernoMunicipal?: number;
  percDespesaConstrucaoNovosPrediosEnsFundEnsMedioEjaGovernoMunicipal?: number;
  percDespesaConstrucaoNovosPrediosEdInfantilTotal?: number;
  percDespesaConstrucaoNovosPrediosEnsFundEnsMedioEjaTotal?: number;

  // Infraestrutura (R4 - Novas Salas)
  financiamentoConstrucaoEdInfantilTamanho1?: number;
  financiamentoConstrucaoCustoTotalNovoPredioEdInfantilTam1?: number;

  financiamentoConstrucaoEdInfantilTamanho2?: number;
  financiamentoConstrucaoCustoTotalNovoPredioEdInfantilTam2?: number;

  financiamentoConstrucaoEnsFunEnsMedioEja1SalaAula?: number;
  financiamentoConstrucaoCustoTotalNovoPredioEnsFunEnsMedioEja1SalaAula?: number;

  financiamentoConstrucaoEnsFunEnsMedioEjaTamanho1?: number; // 2 salas
  financiamentoConstrucaoCustoTotalNovoPredioEnsFunEnsMedioEjaTam1?: number;

  financiamentoConstrucaoEnsFunEnsMedioEjaTamanho2?: number; // 4 salas
  financiamentoConstrucaoCustoTotalNovoPredioEnsFunEnsMedioEjaTam2?: number;

  financiamentoConstrucaoEnsFunEnsMedioEjaTamanho3?: number; // 6 salas
  financiamentoConstrucaoCustoTotalNovoPredioEnsFunEnsMedioEjaTam3?: number;

  financiamentoConstrucaoEnsFunEnsMedioEjaTamanho4?: number; // 12 salas
  financiamentoConstrucaoCustoTotalNovoPredioEnsFunEnsMedioEjaTam4?: number;

  // Detalhamento urbano/rural (R4)
  financiamentoConstrucaoNumNovoPredioEdInfantilTam1Urbana?: number;
  financiamentoConstrucaoNumNovoPredioEdInfantilTam2Urbana?: number;
  financiamentoConstrucaoNumNovoPredioEdInfantil1SalaAulaUrbana?: number;
  financiamentoConstrucaoNumNovoPredioEdInfantilTam1Rural?: number;
  financiamentoConstrucaoNumNovoPredioEdInfantilTam2Rural?: number;
  financiamentoConstrucaoNumNovoPredioEdInfantil1SalaAulaRural?: number;

  financiamentoConstrucaoNumNovoPredioEnsFundEnsMedioEjaTam1Urbana?: number;
  financiamentoConstrucaoNumNovoPredioEnsFundEnsMedioEjaTam2Urbana?: number;
  financiamentoConstrucaoNumNovoPredioEnsFundEnsMedioEjaTam3Urbana?: number;
  financiamentoConstrucaoNumNovoPredioEnsFundEnsMedioEjaTam4Urbana?: number;
  financiamentoConstrucaoNumNovoPredioEnsFundEnsMedioEja1SalaAulaUrbana?: number;

  financiamentoConstrucaoNumNovoPredioEnsFundEnsMedioEjaTam1Rural?: number;
  financiamentoConstrucaoNumNovoPredioEnsFundEnsMedioEjaTam2Rural?: number;
  financiamentoConstrucaoNumNovoPredioEnsFundEnsMedioEjaTam3Rural?: number;
  financiamentoConstrucaoNumNovoPredioEnsFundEnsMedioEjaTam4Rural?: number;
  financiamentoConstrucaoNumNovoPredioEnsFundEnsMedioEja1SalaAulaRural?: number;

  financiamentoConstrucaoCustoTotalNovosPredios?: number;

  // Detalhamento de infraestrutura (novas salas/prédios) - VIX
  detalhamentoInfraestrutura?: LinhaDetalhamentoInfraestruturaDto[];
}

export interface LinhaDetalhamentoInfraestruturaDto {
  etapaModalidade: string;
  tipoConstrucao: string;
  tamanhoM2: number;
  areaLocalidade: string;
  quantidade: number;
  percentual: number;
  custoTotal: number;
}

export const defaultCaqPorEtapaDto: CaqPorEtapaDto = {
  fatorPonderacao: 0,
  mediana: 0,
  numeroMatriculas: 0,
  numeroEscolas: 0,
};

export const defaultDadosRelatorioCaqDto: DadosRelatorioCaqDto = {
  crecheUrbanaIndepLocDiferenciadaParcial: defaultCaqPorEtapaDto,
  crecheUrbanaIndepLocDiferenciadaIntegral: defaultCaqPorEtapaDto,
  preEscolaUrbanaIndepLocDiferenciadaParcial: defaultCaqPorEtapaDto,
  preEscolaUrbanaIndepLocDiferenciadaIntegral: defaultCaqPorEtapaDto,
  ensFunAnosIniciaisUrbanaIndepLocDiferenciadaParcial: defaultCaqPorEtapaDto,
  ensFunAnosIniciaisUrbanaIndepLocDiferenciadaIntegral: defaultCaqPorEtapaDto,
  ensFunAnosFinaisUrbanaIndepLocDiferenciadaParcial: defaultCaqPorEtapaDto,
  ensFunAnosFinaisUrbanaIndepLocDiferenciadaIntegral: defaultCaqPorEtapaDto,
  ensMedioUrbanaIndepLocDiferenciadaParcial: defaultCaqPorEtapaDto,
  ensMedioUrbanaIndepLocDiferenciadaIntegral: defaultCaqPorEtapaDto,
  ejaUrbanaIndepLocDiferenciadaParcial: defaultCaqPorEtapaDto,
  ejaUrbanaIndepLocDiferenciadaIntegral: defaultCaqPorEtapaDto,

  crecheUrbanaParcial: defaultCaqPorEtapaDto,
  crecheUrbanaIntegral: defaultCaqPorEtapaDto,
  crecheRuralParcial: defaultCaqPorEtapaDto,
  crecheRuralIntegral: defaultCaqPorEtapaDto,
  crecheCampoIntegral: defaultCaqPorEtapaDto,
  crecheCampoParcial: defaultCaqPorEtapaDto,
  crecheTerraIndigenaParcial: defaultCaqPorEtapaDto,
  crecheTerraIndigenaIntegral: defaultCaqPorEtapaDto,
  crecheQuilombolaParcial: defaultCaqPorEtapaDto,
  crecheQuilombolaIntegral: defaultCaqPorEtapaDto,

  preEscolaUrbanaParcial: defaultCaqPorEtapaDto,
  preEscolaUrbanaIntegral: defaultCaqPorEtapaDto,
  preEscolaRuralParcial: defaultCaqPorEtapaDto,
  preEscolaRuralIntegral: defaultCaqPorEtapaDto,
  preEscolaCampoParcial: defaultCaqPorEtapaDto,
  preEscolaCampoIntegral: defaultCaqPorEtapaDto,

  preEscolaTerraIndigenaParcial: defaultCaqPorEtapaDto,
  preEscolaTerraIndigenaIntegral: defaultCaqPorEtapaDto,

  preEscolaQuilombolaParcial: defaultCaqPorEtapaDto,
  preEscolaQuilombolaIntegral: defaultCaqPorEtapaDto,

  ensFunAnosIniciaisUrbanaParcial: defaultCaqPorEtapaDto,
  ensFunAnosIniciaisUrbanaIntegral: defaultCaqPorEtapaDto,
  ensFunAnosIniciaisRuralParcial: defaultCaqPorEtapaDto,
  ensFunAnosIniciaisRuralIntegral: defaultCaqPorEtapaDto,
  ensFunAnosIniciaisCampoParcial: defaultCaqPorEtapaDto,
  ensFunAnosIniciaisCampoIntegral: defaultCaqPorEtapaDto,
  ensFunAnosIniciaisTerraIndigenaParcial: defaultCaqPorEtapaDto,
  ensFunAnosIniciaisTerraIndigenaIntegral: defaultCaqPorEtapaDto,
  ensFunAnosIniciaisQuilombolaParcial: defaultCaqPorEtapaDto,
  ensFunAnosIniciaisQuilombolaIntegral: defaultCaqPorEtapaDto,

  ensFunAnosFinaisUrbanaParcial: defaultCaqPorEtapaDto,
  ensFunAnosFinaisUrbanaIntegral: defaultCaqPorEtapaDto,
  ensFunAnosFinaisRuralParcial: defaultCaqPorEtapaDto,
  ensFunAnosFinaisRuralIntegral: defaultCaqPorEtapaDto,
  ensFunAnosFinaisCampoParcial: defaultCaqPorEtapaDto,
  ensFunAnosFinaisCampoIntegral: defaultCaqPorEtapaDto,

  ensFunAnosFinaisTerraIndigenaParcial: defaultCaqPorEtapaDto,
  ensFunAnosFinaisTerraIndigenaIntegral: defaultCaqPorEtapaDto,

  ensFunAnosFinaisQuilombolaParcial: defaultCaqPorEtapaDto,
  ensFunAnosFinaisQuilombolaIntegral: defaultCaqPorEtapaDto,

  ensMedioUrbanaParcial: defaultCaqPorEtapaDto,
  ensMedioUrbanaIntegral: defaultCaqPorEtapaDto,
  ensMedioRuralParcial: defaultCaqPorEtapaDto,
  ensMedioRuralIntegral: defaultCaqPorEtapaDto,
  ensMedioCampoParcial: defaultCaqPorEtapaDto,
  ensMedioCampoIntegral: defaultCaqPorEtapaDto,

  ensMedioTerraIndigenaParcial: defaultCaqPorEtapaDto,
  ensMedioTerraIndigenaIntegral: defaultCaqPorEtapaDto,

  ensMedioQuilombolaParcial: defaultCaqPorEtapaDto,
  ensMedioQuilombolaIntegral: defaultCaqPorEtapaDto,
  ejaUrbanaParcial: defaultCaqPorEtapaDto,
  ejaRuralParcial: defaultCaqPorEtapaDto,
  ejaCampoParcial: defaultCaqPorEtapaDto,
  ejaTerraIndigenaParcial: defaultCaqPorEtapaDto,
  ejaQuilombolaParcial: defaultCaqPorEtapaDto,

  detalhamentoInfraestrutura: [],
};
